import React from "react";
import { Link } from "react-router-dom";
import { fmtUSD, vendorLabel } from "../lib/api";

export default function ProductCard({ product, idx = 0 }) {
  const hasSale = product.compare_at_price && product.compare_at_price > product.price;
  const pctOff = hasSale
    ? Math.round((1 - product.price / product.compare_at_price) * 100)
    : 0;

  return (
    <Link
      to={`/p/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block fade-up"
      style={{ animationDelay: `${Math.min(idx, 12) * 40}ms` }}
    >
      <div className="relative overflow-hidden bg-[#121215] aspect-[4/5]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
        />
        <div className="absolute top-3 left-3 overline text-white">{vendorLabel(product.vendor)}</div>
        {hasSale && (
          <div
            data-testid={`badge-sale-${product.id}`}
            className="absolute top-3 right-3 bg-white text-black text-[10px] font-bold tracking-[0.18em] uppercase px-2 py-1"
          >
            {pctOff}% Off
          </div>
        )}
      </div>
      <div className="pt-4 flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h3 className="font-serif text-lg leading-tight text-white truncate">{product.name}</h3>
          <p className="text-xs text-white/40 mt-1 line-clamp-1">{product.description}</p>
        </div>
        <div className="text-right shrink-0">
          <div className="text-white text-sm font-semibold">{fmtUSD(product.price)}</div>
          {hasSale && (
            <div className="text-[11px] text-white/40 line-through">{fmtUSD(product.compare_at_price)}</div>
          )}
        </div>
      </div>
    </Link>
  );
}
